export const DeployedUrl = "https://iitg-ai-society.vercel.app/";
